// TODO: Temporary, namespaces will need to get more complex after the first few tests
export type Namespace =
  | 'SingleWork'
  | 'TranslationModal'
  | 'DownloadButton'
  | 'BulkDownloadButton'
  | 'MoreActionsPopover'
  | 'WorkStats'
  | 'WorkLinks'
  | 'Sidebar'
  | 'TranslateButton'
  | 'WorkMetadata';

// Keys given to the translation function can be given as a single key,
// or many keys, where subsequent keys serve as fallbacks.
export type KeyParam = string | string[];

// Only supported locales are listed here
export const LOCALE_NAMES = {
  cs: 'Czech',
  de: 'German',
  el: 'Greek',
  en: 'English',
  es: 'Spanish',
  fi: 'Finnish',
  fr: 'French',
  he: 'Hebrew',
  hu: 'Hungarian',
  id: 'Indonesian',
  it: 'Italian',
  ja: 'Japanese',
  ko: 'Korean',
  nl: 'Dutch',
  no: 'Norwegian',
  pl: 'Polish',
  pt: 'Portuguese',
  ro: 'Romanian',
  ru: 'Russian',
  sr: 'Serbian',
  sv: 'Swedish',
  tr: 'Turkish',
  zh: 'Chinese',
  // Only enabled in dev, enables falling back to easy to spot garbled text
  dev: 'Development',
};

export type LocaleCode = keyof typeof LOCALE_NAMES;

export const BASE_LOCALE = 'en';
